<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Evolución de Sueldos</strong>
          </div>
          <b-form>
            <b-form-group
              label="Desde"
              label-for="periodoDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-select 
                v-model="periodoDesdeMesNombre" 
                :options="meses" 
                class="mb-3 select-fecha select-fecha-mes">
                <template slot="first">
                  <option :value="null">Seleccione un mes</option>
                </template>
              </b-form-select>
              <b-form-select 
                v-model="periodoDesdeAnio" 
                :options="anios" 
                class="mb-3 select-fecha select-fecha-anio">
                <template slot="first">
                  <option :value="0">Seleccione un año</option>
                </template>
              </b-form-select>
            </b-form-group>

            <b-form-group
              label="Hasta"
              label-for="periodoHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-select 
                v-model="periodoHastaMesNombre" 
                :options="meses" 
                class="mb-3 select-fecha select-fecha-mes">
                <template slot="first">
                  <option :value="null">Seleccione un mes</option>
                </template>
              </b-form-select>
              <b-form-select 
                v-model="periodoHastaAnio" 
                :options="anios" 
                class="mb-3 select-fecha select-fecha-anio">
                <template slot="first">
                  <option :value="0">Seleccione un año</option>
                </template>
              </b-form-select>
            </b-form-group>

            <b-form-group
              label="Personal"
              label-for="personal"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarPersonal">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !personal,
                                  'fa fa-remove': personal  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="personal"
                  :value="personalNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Importes a incluir"
              :label-cols="labelCols * 4"
              horizontal>
            </b-form-group>

            <b-row>
              <b-col xl="4">
                <b-form-group
                  :label-cols="labelCols * 3"
                  horizontal>
                  <b-form-checkbox 
                      id="honorarios"
                      v-model="honorarios"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Honorarios
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col xl="4">
                <b-form-group
                  :label-cols="labelCols * 3"
                  horizontal>
                  <b-form-checkbox 
                      id="adicional"
                      v-model="adicional"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Adicional
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col xl="4">
                <b-form-group
                  :label-cols="labelCols * 3"
                  horizontal>
                  <b-form-checkbox 
                      id="otrosConceptos"
                      v-model="otrosConceptos"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Otros Conceptos
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col xl="4">
                <b-form-group
                  :label-cols="labelCols * 3"
                  horizontal>
                  <b-form-checkbox 
                      id="liquidacionFinal"
                      v-model="liquidacionFinal"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Liquidación Final
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchPersonalModal" 
        title="Seleccionar Personal"
        header-bg-variant="light" 
        hide-footer
        lazy
        modal-class="personal-search-modal">
      <app-search-personal
        @personalSeleccionado="personalSeleccionado">
      </app-search-personal>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchPersonal from '../personal/SearchList.vue'
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import exportXlsPersonal from '../../mixins/export_xls_personal';
import moment from 'moment';

export default {
  name: 'RptEvolucion',
  components: {
    appSearchPersonal: SearchPersonal,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
    exportXlsPersonal
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      periodoDesdeMesNombre: null,
      periodoDesdeAnio: 0,
      periodoHastaMesNombre: null,
      periodoHastaAnio: 0,
      personal: null,
      honorarios: true,
      adicional: true,
      otrosConceptos: true,
      liquidacionFinal: true,

      labelCols: 1,
      meses: [],
      anios: []
    }
  },
  created() {
    this.meses = this.getMeses();
    this.anios = this.getAniosPeriodo();

    let fecha = moment.utc(new Date()).format('YYYY-MM-DD')

    this.periodoDesdeMes= new Date(fecha).getMonth() + 1;
    this.periodoDesdeMesNombre= this.getMesNombre(this.periodoDesdeMes);
    this.periodoDesdeAnio= new Date(fecha).getFullYear();

    this.periodoHastaMes= new Date(fecha).getMonth() + 1;
    this.periodoHastaMesNombre= this.getMesNombre(this.periodoHastaMes);
    this.periodoHastaAnio= new Date(fecha).getFullYear();
  },
  computed: {
    personalNombre() {
      return this.personal? this.personal.nombre.trim() : '';
    },
  },
  methods: {
    validate() {
    },
    seleccionarPersonal() {
      if (this.personal) {
        this.personal = null;
      } else {
        this.$refs.searchPersonalModal.show()
      }
    },
    personalSeleccionado(personal) {
      this.$refs.searchPersonalModal.hide();
      this.personal = personal;
    },
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let fechaDesde = parseInt(this.periodoDesdeAnio).toString().trim()
          + '-' + this.getMesNumeroToString(this.periodoDesdeMesNombre).trim()
          + '-01';

      let fechaHasta = parseInt(this.periodoHastaAnio).toString().trim()
          + '-' + this.getMesNumeroToString(this.periodoHastaMesNombre).trim()
          + '-01';

      let personalId = 0;
      if (this.personal) {
        if (this.personal.id) {
          personalId = this.personal.id;
        }
      }

      if ((/true/i).test(this.honorarios) == false 
          & (/true/i).test(this.adicional) == false
          & (/true/i).test(this.otrosConceptos) == false
          & (/true/i).test(this.liquidacionFinal) == false) {
        
        this.showModalMsj('Debe seleccionar al menos uno de los importes a incluir en el reporte.', null, null, 'light');
        execute = false;
      }

      let params = {
        fechaDesde,
        fechaHasta,
        personalId
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('liquidacionesSueldos/getRptEvolucionSueldos', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptEvolucionSueldos = this.$store.getters['liquidacionesSueldos/rptEvolucionSueldos'];

            if (rptEvolucionSueldos) {
              if (rptEvolucionSueldos.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              /* Calculamos el total según las opciones seleccionadas */
              rptEvolucionSueldos.forEach(personal => {
                if (personal.periodos) {
                  personal.periodos.forEach(periodoLiquidacion => {

                    periodoLiquidacion.total = 0;

                    if ((/true/i).test(this.honorarios)) {
                      periodoLiquidacion.total += periodoLiquidacion.honorarios;
                    }
                    if ((/true/i).test(this.adicional)) {
                      periodoLiquidacion.total += periodoLiquidacion.adicional;
                    }
                    if ((/true/i).test(this.otrosConceptos)) {
                      periodoLiquidacion.total += periodoLiquidacion.otrosConceptos;
                    }
                    if ((/true/i).test(this.liquidacionFinal)) {
                      periodoLiquidacion.total += periodoLiquidacion.liquidacionFinal;
                    }
                  });
                }
              });

              this.exportXLSRptEvolucionSueldos(rptEvolucionSueldos);
            } else {
              this.showModalMsj('No hay datos para exportar.', null, null, 'light');
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    goBack() {

    },
  },
}
</script>

<style>
</style>
